<template>
  <div style="flex:1">
    <van-pull-refresh v-model="refreshing" @refresh="refresh">
      <slot name="list-head-view" />
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="(dataList && dataList.length > 0) ? '' : ''"
        @load="onLoad"
      >
        <slot name="list" v-bind:dataList="dataList ? dataList : []"/>

        <div v-if="dataList && dataList.length == 0" :style="{height:`${bodyHeight - offset}px`}" class="empty_container">
          <van-empty description="暂无数据" />
        </div>

      </van-list>
    </van-pull-refresh>

  </div>
</template>
<script>
export default {
  props: {
    requestMethod: { type: Function},//请求方法
    requestParams: { type: Object}, //请求参数拓展
    listName: { type: String}, //返回列表字段名
    pageSize: { type: Number, default: 20}, //分页数量，默认20
    offset: { type: Number, default: 0}, //空白页高度差
  },
  data() {
    return {
      bodyHeight:document.body.clientHeight,
      loading: false,
      refreshing: false,
      finished: false,
      index:1,
      dataList: null,
    };
  },
  methods: {
    onLoad() {
      this.requestDataList(this.index);
    },
    refresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.requestDataList(1);
      this.$emit('onRefresh')
    },
    //请求数据列表
    requestDataList(index){
      this.loading = true;
      let params = {
        pageNum:index,
        pageSize:this.pageSize
      }
      if(this.requestParams) {
        params = {
          ...params,
          ...this.requestParams,
        }
      }
      if(this.requestMethod && this.listName) {
        this.requestMethod(params, (resp)=>{
          this.loading = false;
          this.refreshing = false;
          this.$emit('onSuccess', resp)
          let list = resp.result[this.listName] ? resp.result[this.listName] : [];
          if(list.length < this.pageSize) {
            this.finished = true;
          }
          if(index == 1) {
            this.dataList = list;
          } else {
            this.dataList = [...this.dataList, ...list]
          }
          this.index = index + 1;
        }, (failResp)=>{
          //请求失败
          this.loading = false;
          this.refreshing = false;

          if(this.dataList == null || this.dataList.length == 0) {
            this.dataList = []
            this.finished = true;
          }
        })
      }
    },
  },
};
</script>
<style lang="less">
.empty_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .van-empty {
    margin-bottom: 2.5rem;
  }
}
</style>
